import type { FormSegment, SegmentTreeNode } from '../../../../../../../../../modules/audiences/AudienceForm/types.ts';
import { buildAllSegmentsMap } from './buildAllSegmentsMap.ts';
import { buildSegmentMaps } from './buildSegmentMaps.ts';
import { createStateNode } from './createStateNode.ts';

export const transformSegmentsToStateDistrictTree = (
  segments: FormSegment[],
  allSegments: SegmentTreeNode[] = []
): SegmentTreeNode[] => {
  if (!segments.length) return [];

  const { districtsByParentId, uniqueParentIds } = buildSegmentMaps(segments);

  const allSegmentsById: Map<string, SegmentTreeNode> = buildAllSegmentsMap(allSegments);

  const result: SegmentTreeNode[] = [];

  uniqueParentIds.forEach(parentId => {
    const districts = districtsByParentId.get(parentId) || [];

    const stateNode = createStateNode({ parentId, districts, allSegmentsById });

    result.push(stateNode);
  });

  return result;
};
